import {Role} from '../../../components/modals/time-registration/time-registration-modal/types/TimeRegistrationRole';

export const getDefaultRole = (
	existingRole: Role | null | undefined,
	projectPersonRole: Role | null | undefined,
	taskRole: Role | null | undefined,
	companyRole: Role | null | undefined
): Role | null => {
	if (existingRole) {
		return existingRole;
	}
	if (projectPersonRole) {
		return projectPersonRole;
	}
	if (taskRole) {
		return taskRole;
	}
	if (companyRole) {
		return companyRole;
	}
	return null;
};
